module.exports = __webpack_public_path__ + "img/dsci0129.3356e8e7.jpg";